import type { FunctionComponent } from 'react'
import React from 'react'
import { Hr, TypographyV2 as Typography } from '@which/seatbelt/'

import { Link } from '../../../../shared/components/Link'
import styles from './WhichConnectMessage.module.scss'

export const WhichConnectMessage: FunctionComponent<Props> = ({ showMessage }) => {
  if (!showMessage) {
    return null
  }

  return (
    <div data-testid="which-connect-message" className={styles.whichConnectMessage}>
      <Hr />
      <Typography textStyle="sb-text-interface-body-small-regular">
        This article uses insights from the Which? Connect panel, collected from research activities
        with our members.{' '}
        <Link href="https://www.which.co.uk/about-which/join-which-connect-aiO165H5gPZE">
          Find out how to get involved
        </Link>
      </Typography>
      <Hr />
    </div>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  showMessage: boolean
}
